import React from 'react';
import cx from 'classnames';

import type { DatagridHeaderProps } from '../../Datagrid.types';
import { CellTextAlign } from '../../Datagrid.types';

import DatagridHeaderCell from './DatagridHeaderCell/DatagridHeaderCell';

import styles from './DatagridHeader.module.scss';

export const DatagridHeader: React.FC<DatagridHeaderProps> = ({
	columns,
	containerClassName,
	gridClass,
	onSortHandler,
	...props
}) => (
	<div className={containerClassName} role="rowgroup" {...props}>
		<div aria-rowindex={1} className={cx(styles.datagridHeader, gridClass)} role="rowheader">
			{columns?.map(
				({ cypressId, id, sortable = false, sortDirection, text, textAlign = CellTextAlign.Left }, index) => (
					<DatagridHeaderCell
						key={id}
						cypressId={cypressId}
						id={id}
						index={index}
						onSortHandler={onSortHandler}
						sortDirection={sortDirection}
						sortable={sortable}
						text={text}
						textAlign={textAlign}
					/>
				),
			)}
		</div>
	</div>
);
